import { render } from "./ButtonShow.vue?vue&type=template&id=0023cc41"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__